import React from "react";
import ToogleSearch from "../Header/ToggleSearch";
import MobileMenu from "../Header/MobileMenu";
import Login from "../Header/logins/login";
import { Outlet, Link } from "react-router-dom";

export default function Header() {
  return (
    <>
      <header id="masthead" className="site-header header-primary">
        {/* header html start */}
        <div className="top-header">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 d-none d-lg-block">
                <div className="header-contact-info">
                  <ul>
                    <li>
                      <a href="tel:03084534190">
                        <i className="fas fa-phone-alt" /> +92 3084534190
                      </a>
                    </li>
                    <li>
                      <a href="mailto:sameerhassan888@gmail.com">
                        <i className="fas fa-envelope" />{" "}
                        sameerhassan888@gmail.com
                      </a>
                    </li>
                    <li>
                      <i className="fas fa-map-marker-alt" />
                      Lahore, Pakistan
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4 d-flex justify-content-lg-end justify-content-between">
                <div className="header-social social-links">
                  <ul>
                    <li>
                      <a href="tel:03084534190">
                        <i className="fab fa-facebook-f" aria-hidden="true" />
                      </a>
                    </li>
                    <li>
                      <a href="tel:03084534190">
                        <i className="fab fa-twitter" aria-hidden="true" />
                      </a>
                    </li>
                    <li>
                      <a href="tel:03084534190">
                        <i className="fab fa-instagram" aria-hidden="true" />
                      </a>
                    </li>
                    <li>
                      <a href="tel:03084534190">
                        <i className="fab fa-linkedin" aria-hidden="true" />
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="header-search-icon">
                  <ToogleSearch />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bottom-header">
          <div className="container d-flex justify-content-between align-items-center">
            <div className="site-identity">
              <h1 className="site-title">
                <Link to="/">
                  <img
                    className="white-logo"
                    src="https://res.cloudinary.com/debltnmge/image/upload/v1684610968/JourneyScape1_kdfny7.webp"
                    alt="logo"
                  />
                  <img
                    className="black-logo"
                    src="/sandbox/src/assets/images/JourneyScape1.webp"
                    alt="logo"
                  />
                </Link>
              </h1>
            </div>
            <div className="main-navigation d-none d-lg-block">
              <nav id="navigation" className="navigation">
                <ul>
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <Link to="/TourPackages">Tour Packages</Link>
                  </li>
                  <li className="menu-item-has-children">
                    <a href="#">Province Packages</a>
                    <ul>
                      <li>
                        <Link to="/Punjab">Punjab</Link>
                      </li>
                      <li>
                        <Link to="/Sindh">Sindh</Link>
                      </li>
                      <li>
                       <Link to="/Balochistan">Balochistan</Link>
                      </li>
                      <li>
                       <Link to="/KPK">KPK</Link>
                      </li>
                      <li>
                       <Link to="/GilgitBaltistan">Gilgit Baltistan</Link>
                      </li>
                      <li>
                       <Link to="/AzadKashmir">Azad Kashmir</Link>
                      </li>
                    </ul>
                  </li>

                  <li>
                    <Link to="/About">About</Link>
                  </li>
                  <li>
                    <Link to="/Contact">Contact</Link>
                  </li>
                </ul>
              </nav>
            </div>
            <div className="header-btn">
              <Login />
            </div>
          </div>
        </div>
        <MobileMenu />
      </header>
      <Outlet />
    </>
  );
}
